module.exports = __webpack_public_path__ + "img/icon_qingpai_des_3.64094614.jpg";